// let apiUrl = 'http://global.aitrans.org.cn/service'; // 线上
let apiUrl = 'http://182.43.222.102:8082/service'; // 线上
// let apiUrl = 'http://localhost:8082/service'; // 线上
// let apiUrl = 'http://y406x20468.qicp.vip/service'; // 测试
let apiTestUrl = 'http://global.aitrans.org.cn/old'; // 测试
// let apiTestUrl = 'http://localhost:8086/old'; // 测试
// let apiTestUrl = 'http://114.115.179.25:8082/old'; // 测试
let uploadFileUrl = 'http://114.115.179.25:8082'

// let apiTestUrl = 'http://182.43.222.102:8082/trans'; // 线上
// let apiUrl = 'http://127.0.0.1:8082/service'; // 测试

// 聊天室地址
let wsUrl = 'ws://182.43.222.102:8082/service' // 线上
    // let wsUrl = 'ws://y406x20468.qicp.vip/service' // 测试

// 图片上传地址
let uploadUrl = apiUrl + '/case/fileUpload';
let uploadTestUrl = apiTestUrl + '/file/fileUpload.do';
// let uploadTestUrl = apiTestUrl + '/file/fileFlowUpload.do';
// let uploadTestUrl = 'http://127.0.0.1:8087/h5/custOrder/fileUpload';

const config = {
    apiUrl,
    wsUrl,
    uploadUrl,
    apiTestUrl,
    uploadTestUrl,
    uploadFileUrl
}

module.exports = config;